module.exports = __webpack_public_path__ + "static/derave-video-07b9de5ccbe2ab22d65b7549dfa7eeb3.webm";